<template>
  <div class="feedback-link">
    <ELink
      as="span"
      color="secondary"
      v-bind="$attrs"
      role="button"
      tabindex="0"
      data-test-id="feedback-link"
      :aria-pressed="!!modalActive"
      @click="onClick"
      @keydown.enter="onClick"
      @keydown.space="onClick"
      v-on="$listeners"
    >
      <slot />
    </ELink>
    <EFeedbackModal v-bind="$props" :active="modalActive" @close="onClose" />
  </div>
</template>

<script>
import ELink from '~~/common/vue/components/link';
import EFeedbackModal from '~~/common/vue/components/feedback-modal';

export default {
  name: 'EFeedbackLink',
  components: {
    ELink,
    EFeedbackModal,
  },
  props: {
    ...EFeedbackModal.props,
  },
  data() {
    return {
      modalActive: false,
    };
  },
  methods: {
    onClick() {
      this.modalActive = true;
    },
    onClose() {
      this.modalActive = false;
    },
  },
};
</script>

<docs>
The link that calls the FeedbackModal.
It passes all the extra attributes to the FeedbackModal

### States

#### Default

```js
const options = ['I like the feature', 'Something is missing',
  'I don\'t find this useful', 'I don\'t understand this'];
const subjects= ['Log-in feature', 'Personal counter', 'General']
<EFeedbackLink
  ticket-subject="Search - My app"
  title="What is your feedback?"
  success-title="Success"
  success-message="Thank you"
  textarea-placeholder="Tell us more (optional)"
  subjects-placeholder="Please choose an option"
  button-text="Send"
  :options="options"
  :subjects="subjects"
  url="https://httpstat.us/200"
  error-message="Oops, there was an error sending feedback"
>
  Feedback
</EFeedbackLink>
```

</docs>
